import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './alert.module.scss';

const Alert = ({ type, children }) => (
  <div className={classnames(styles.alert, styles[type])}>{children}</div>
);

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Alert;
